import { Quote } from '@shared/types/quote';
import { getFreightMode } from 'clerk_common/templates/freight_order/fieldExtractors/fieldExtractors';

export const getQuoteWarnings = (quote: Quote): string[] => {
  const warnings: string[] = [];
  const freightMode = getFreightMode(quote.extractedData);

  if (freightMode === 'LTL') {
    warnings.push('This may be an LTL quote');
  }

  return warnings;
};
